<template>
  <v-form
    ref="form"
    :model="valid"
    lazy-validation>
    <v-progress-linear height="3px"
                       v-show="loading" color="primary" indeterminate></v-progress-linear>
    <v-card>
      <v-card-title>
        <span class="title">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap column v-for="col in dialogKeys"
                    :key="col.value">
            <div v-if="isAdmin && isEdit && isDetail === false">
              <quill-editor ref="QuillEditor" v-if="col.value === 'content'"
                            v-model="editedItem[col.value]"
                            :options="editorOption"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)"
              />
              <v-text-field v-else v-model="editedItem[col.value]" :label="col.text"
                            :disabled="col.disabled"
                            :required="col.required"></v-text-field>
            </div>
            <div v-else>
              <div v-if="col.value === 'content'" v-html="editedItem[col.value]"></div>
              <div v-else><span class="title">標題：{{editedItem[col.value]}}</span></div>
            </div>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="save" v-if="isEdit && isAdmin"
               :loading="saveLoading"
               :disabled="saveLoading">儲存</v-btn>
        <v-btn color="red" dark @click="back">返回</v-btn>
      </v-card-actions>
    </v-card>

    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.content"
                :show-cancel="messageDialog.showCancel"
                @confirmEvent="messageDialog.confirm"
                @cancelEvent="messageDialog.cancel"></alert-view>
  </v-form>
</template>

<script>
  import { quillEditor } from 'vue-quill-editor';
  import { mapActions, mapGetters } from 'vuex';
  import AlertView from '@/components/AlertView';
  import QuestionView from '../../components/QuestionView';
  export default {
    name: 'NoticeDetailView',
    components:{
      QuestionView,
      quillEditor,
      AlertView
    },
    data() {
      return {
        loading: false,
        saveLoading: false,
        valid: false,
        editorOption: {},
        editedItem: {
          title:'',
          content:'',
          owner:'',
          enable: true,
        },
        messageDialog: {
          visible: false,
          title: '',
          content: '',
          showCancel: false,
          confirm: ()=>{},
          cancel:()=>{},
        },
        editedIndex: -1,
        isDetail: false,
      }
    },
    created() {
      this.isDetail = this.$route.query.edit === 0;
      // console.log(`isDetail === ${this.$route.query.edit} / ${this.isDetail}`)
      if (this.$route.query.id === ''){
        this.editedIndex = -1;
      } else {
        this.editedIndex = 0;
        this.loadData();
      }
    },
    computed:{
      ...mapGetters(['getUserInfo']),
      editor() {
        return this.$refs.QuillEditor.quill
      },
      dialogKeys() {
        return [
          { value: 'title', text: '標題', sortable: true  ,required: true},
          { value: 'content', text: '內容', sortable: true  ,required: true},
        ]
      },
      formTitle() {
        if (this.isEdit && this.isDetail === false){
          return this.$route.query.id === '' ? '新增' : '編輯';
        } else {
          return '明細';
        }
      },
      isAdmin() {
        return this.getUserInfo.authority === 'admin';
      },
      isEdit(){
        if (this.$route.query.id !== '' || this.isDetail === false){
          return true;
        }
        return false;
      },
    },
    methods: {
      ...mapActions(['getNoticeList', 'createNotice', 'saveNotice', 'deleteNotice','getNoticeInfo']),
      async loadData(){
        const noticeId = this.$route.query.id;
        if (noticeId && noticeId !== ''){
          this.loading = true;
          const res = await this.getNoticeInfo({noticeId:noticeId});
          if (res.data.statusCode === 0){
            this.editedItem = res.data.data;
          }
          this.loading = false;
        }

      },
      onEditorBlur(quill) {
        console.log('editor blur!', quill)
      },
      onEditorFocus(quill) {
        console.log('editor focus!', quill)
      },
      onEditorReady(quill) {
        console.log('editor ready!', quill);
        quill.container.style.height = '500px';
      },
      back(){
        this.$router.back();
      },
      async save(){
        this.saveLoading = true;

        this.editedItem.owner = this.getUserInfo.agentId;
        let res;
        if (this.editedIndex === -1){
          res = await this.createNotice(this.editedItem);
        } else {
          res = await this.saveNotice(this.editedItem);
        }
        this.saveLoading = false;
        if (res){
          if (res.data.statusCode === 0){
            this.showDialog(true , '成功', res.data.message, false,
              ()=> {
                this.closeDialog();
              },
              ()=>{
                this.closeDialog();
              });
          } else {
            this.showDialog(true , '錯誤', res.data.message, false,
              ()=> {
                this.closeDialog();
              },
              ()=>{
                this.closeDialog();
              });
          }
        } else {
          this.showDialog(true , '錯誤', '建立失敗', false,
            ()=> {
              this.closeDialog();
            },
            ()=>{
              this.closeDialog();
            });
        }
      },
      async remove(notice){
        this.saveLoading = true;
        const res = await this.deleteNotice({ noticeId: notice.noticeId });
        this.saveLoading = false;
        if (res){
          if (res.data.statusCode === 0){
            this.showDialog(true , '成功', res.data.message, false,
              ()=> {
                this.closeDialog();
                this.back();
              },
              ()=>{
                this.closeDialog();
              });
          } else {
            this.showDialog(true , '錯誤', res.data.message, false,
              ()=> {
                this.closeDialog();
              },
              ()=>{
                this.closeDialog();
              });
          }
        } else {
          this.showDialog(true , '錯誤', '刪除失敗', false,
            ()=> {
              this.closeDialog();
            },
            ()=>{
              this.closeDialog();
            });
        }
      },
      showDialog(visible, title, content, showCancel, confirm, cancel) {
        this.messageDialog.visible = visible;
        this.messageDialog.title = title;
        this.messageDialog.content = content;
        this.messageDialog.showCancel = showCancel;
        this.messageDialog.confirm = confirm;
        this.messageDialog.cancel = cancel;
      },
      closeDialog(){
        this.messageDialog.visible = false;
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/NoticeDetailView.vue